export interface CategoryLink {
  name: string;
  url: string;
  slug: string;
}

export const categoryLinks: CategoryLink[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', slug: 'shoes' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', slug: 'hoodies-sweaters' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', slug: 't-shirts' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', slug: 'jackets' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', slug: 'pants-shorts' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', slug: 'headwear' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', slug: 'sets' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', slug: 'underwear' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', slug: 'jersey' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', slug: 'accessories' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', slug: 'bags' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', slug: 'belts' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', slug: 'perfumes' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', slug: 'other-stuff' },
];

export interface FeaturedItem {
  product: string;
  category: string;
  seller: string;
  qc: string;
  guide: string;
}

export const featuredItems: FeaturedItem[] = [
  { product: 'Premium Sneakers Collection', category: 'Shoes', seller: 'Verified Seller', qc: 'Available', guide: 'View Guide' },
  { product: 'Designer Hoodies Pack', category: 'Hoodies / Sweaters', seller: 'Top Rated', qc: 'Available', guide: 'View Guide' },
  { product: 'Streetwear T-Shirts Set', category: 'T-Shirts', seller: 'Trusted', qc: 'On Request', guide: 'View Guide' },
  { product: 'Winter Jacket Selection', category: 'Jackets', seller: 'Verified', qc: 'Available', guide: 'View Guide' },
  { product: 'Cargo Pants & Shorts', category: 'Pants / Shorts', seller: 'Popular', qc: 'Available', guide: 'View Guide' },
  { product: 'Luxury Accessories Bundle', category: 'Accessories', seller: 'Top Rated', qc: 'Available', guide: 'View Guide' },
];

export interface GuideCard {
  titleKey: string;
  slug: string;
  desc: string;
}

export const guideCards: GuideCard[] = [
  { titleKey: 'guide_spreadsheet', slug: 'allchinabuy-spreadsheet-guide', desc: 'Complete overview of curated product lists, seller directories, QC notes and shipping references in one organized system.' },
  { titleKey: 'guide_review', slug: 'allchinabuy-review', desc: 'Comprehensive platform review covering service quality, user experience, and reliability factors.' },
  { titleKey: 'guide_shipping', slug: 'allchinabuy-shipping-cost', desc: 'Complete breakdown of shipping methods, costs, delivery times, and customs considerations.' },
  { titleKey: 'guide_coupon', slug: 'allchinabuy-coupon', desc: 'Current coupon availability, seasonal promotions, and money-saving strategies.' },
  { titleKey: 'guide_discount', slug: 'allchinabuy-discount-code', desc: 'Active discount codes, referral programs, and promotional offers overview.' },
  { titleKey: 'guide_warehouse', slug: 'allchinabuy-warehouse', desc: 'Understanding warehouse processes, storage, inspection, and consolidation services.' },
  { titleKey: 'guide_legit', slug: 'is-allchinabuy-legit', desc: 'Safety assessment, legitimacy factors, and risk management for new buyers.' },
  { titleKey: 'guide_qc', slug: 'allchinabuy-qc-guide', desc: 'How to request, interpret, and use quality control photos effectively.' },
  { titleKey: 'guide_order', slug: 'how-to-order-allchinabuy', desc: 'Step-by-step ordering process from account setup to parcel delivery.' },
  { titleKey: 'guide_buying', slug: 'allchinabuy-buying-guide', desc: 'Essential buying advice for beginners, from seller research to shipping budgeting.' },
];

export interface FaqItem {
  qKey: string;
  aKey: string;
}

export const faqItems: FaqItem[] = [
  { qKey: 'faq_q1', aKey: 'faq_a1' },
  { qKey: 'faq_q2', aKey: 'faq_a2' },
  { qKey: 'faq_q3', aKey: 'faq_a3' },
  { qKey: 'faq_q4', aKey: 'faq_a4' },
  { qKey: 'faq_q5', aKey: 'faq_a5' },
  { qKey: 'faq_q6', aKey: 'faq_a6' },
  { qKey: 'faq_q7', aKey: 'faq_a7' },
  { qKey: 'faq_q8', aKey: 'faq_a8' },
];

export interface ComparisonRow {
  feature: string;
  allchinabuy: string;
  superbuy: string;
  cssbuy: string;
  sugargoo: string;
  pandabuy: string;
}

export const comparisonData: ComparisonRow[] = [
  { feature: 'Service Fee', allchinabuy: 'Check current rates', superbuy: 'Check current rates', cssbuy: 'Check current rates', sugargoo: 'Check current rates', pandabuy: 'Check current rates' },
  { feature: 'QC Photos', allchinabuy: 'Available', superbuy: 'Available', cssbuy: 'Available', sugargoo: 'Available', pandabuy: 'Available' },
  { feature: 'Shipping Lines', allchinabuy: 'Multiple options', superbuy: 'Multiple options', cssbuy: 'Multiple options', sugargoo: 'Multiple options', pandabuy: 'Multiple options' },
  { feature: 'Insurance', allchinabuy: 'Optional', superbuy: 'Optional', cssbuy: 'Optional', sugargoo: 'Optional', pandabuy: 'Optional' },
  { feature: 'Mobile App', allchinabuy: 'Available', superbuy: 'Available', cssbuy: 'Web-based', sugargoo: 'Available', pandabuy: 'Available' },
  { feature: 'Live Chat Support', allchinabuy: 'Check availability', superbuy: '24/7', cssbuy: 'Business hours', sugargoo: 'Business hours', pandabuy: '24/7' },
];